export default "__VITE_ASSET__31350bb8__"